import PageContainer from 'src/components/PageContainer';
import PageTitle from 'src/components/PageTitle';
import {useTranslations} from 'src/components/TranslationsContext';
import {useCurrentOrganization} from 'src/hooks/useAuth';
import {ApiUserProfile} from 'src/lib/api/auth';

import ForecastThresholdNotifications from './ForecastThresholdNotifications';
import NewForecastNotifications from './NewForecastNotifications';

type Props = {
  currentUser: ApiUserProfile;
};

export default function Notifications({currentUser}: Props) {
  const {t} = useTranslations();
  const currentOrg = useCurrentOrganization()!;

  return (
    <PageContainer>
      <PageTitle
        pageStack={[
          {title: currentOrg.name, to: '/:currentOrgIdPrefix/projects'},
          {title: t('settings'), to: '/:currentOrgIdPrefix/settings'},
          {
            title: t('notificationsAndAlerts'),
            to: '/:currentOrgIdPrefix/settings/notifications',
          },
        ]}
      />
      <div className="space-y-4">
        <NewForecastNotifications />
        <ForecastThresholdNotifications currentUser={currentUser} />
      </div>
    </PageContainer>
  );
}
